import React from "react";
import { useFormContext } from "react-hook-form";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import { getApiErrorMessage, classifyError } from "utils/api-error";
import { toast } from "react-toastify";

// Recipe P6: the host form's handleSubmit rethrows anything the submit
// callback throws, so toast instead of failing silently. Same shape as
// preset-question-response.js's toastSubmitError, kept local to this file.
const toastSubmitError = (err) =>
    toast.error(getApiErrorMessage(classifyError(err), "respond"));

// Renders inside the preset form's FormProvider and submits the host form
// programmatically through the parent's submitRef (recipe P6): this dialog
// has no <form> of its own, so no submit-event bubbling concerns.
export default function DeleteCustomAnswerDialog({
    showDialog,
    handleClose,
    setShowDialog,
    setReallyDeleteCustom,
    question,
    questionPresets,
    submitRef,
}) {
    const { setValue } = useFormContext();

    // Recipe P6: submitRef.current() runs the host form's handleSubmit,
    // which rethrows anything the submit callback throws; toast it.
    const submitHostForm = () => {
        submitRef.current().catch(toastSubmitError);
    };

    const handleConfirmCustomDelete = () => {
        setReallyDeleteCustom(true);
        setShowDialog(false);
        submitHostForm();
    };

    const handleDenyCustomDelete = () => {
        if (question.answer_type === "single") {
            setValue(
                "answer",
                new Array(questionPresets.preset_answers.length),
                { shouldDirty: true },
            );
        }
        setShowDialog(false);
        submitHostForm();
    };

    return (
        <Dialog
            open={showDialog}
            handler={handleClose}
            className="dialog"
            size="lg"
            animate={{
                mount: { scale: 1, y: 0 },
                unmount: { scale: 1, y: -100 },
            }}
        >
            <DialogHeader className="dialog__header">
                Are you sure you wish to remove your typed response?
            </DialogHeader>
            <DialogBody className="dialog__body">
                Choosing this option will remove your typed response, did you
                really want to do that?
            </DialogBody>
            <DialogFooter className="dialog__footer">
                <div className="bottom-2">
                    <Button
                        type="button"
                        className="btn btn--secondary"
                        variant="outlined"
                        onClick={() => handleDenyCustomDelete()}
                    >
                        No, keep my response
                    </Button>
                </div>
                <div className="bottom-2">
                    <Button
                        type="button"
                        className="btn btn--primary"
                        variant="filled"
                        onClick={() => handleConfirmCustomDelete()}
                    >
                        Yes, change my response
                    </Button>
                </div>
            </DialogFooter>
        </Dialog>
    );
}
